<template>
    <div>
        <div style="position: fixed;width: 100%;height: 100%;z-index: 999;opacity: 1;background-color: #fff;">
            <div style="text-align: center;margin-top: 60px;">
                <img src="@/assets/pdf/hawkeye.jpg" style="width: 180px;height: 180px;">
                <div class="indexInfoDiv">
                    <div style="font-size: 30px;margin-top: 15px;">弈客鹰眼5.0智能棋评</div>
                    <div style="margin-top: 40px;font-size: 15px;line-height: 26px;">
                        <div>{{text}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getPdf } from '@/request/api'
    export default {
        data() {
            return {
                token: "",
                teacher: "",
                institution: "",
                text: "正在生成鹰眼报告",
            }
        },
        created() {
            this.token = this.getQueryVariable('token')
            this.teacher = this.getQueryVariable('teacher')
            this.institution = this.getQueryVariable('institution')
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                let req = {
                    token: this.token,
                    teacher: this.teacher,
                    institution: this.institution
                };
                setInterval(() => {
                    this.text = this.text + "."
                }, 1000);

                getPdf(req).then(result => {
                    if (result.code == 0) {
                        var res = result.data
                        setTimeout(() => {
                            window.location.href = res.url + "?t=" + Date.now()
                            // window.location.replace(res.url)
                        }, 1000);
                    } else {
                        if (result.msg) {
                            alert(result.msg)
                        }
                    }
                }).catch(err => {
                    if (err.msg) {
                        alert(err.msg)
                    }
                })
            },

            // 获取参数
            getQueryVariable(variable) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) {
                        return decodeURI(pair[1]);
                    }
                }
                return "";
            },
        }
    }
</script>
<style>

</style>